import AuditStep3 from '../../AuditCreationModal/AuditStep3/AuditStep3';

const ProcessAuditStep3 = (props) => {
	return <AuditStep3 {...props} />;
};

export default ProcessAuditStep3;
